import { computeAddress, SigningKey } from 'ethers'

export function compressedPublicKeyToAddress(compressedPublicKey: string): string {
  try {
    if (!compressedPublicKey.startsWith('0x')) {
      compressedPublicKey = '0x' + compressedPublicKey
    }

    const publicKey = SigningKey.computePublicKey(compressedPublicKey, false)

    const address = computeAddress(publicKey)

    return address
  } catch (error) {
    console.error('Error converting public key to address:', error)
    throw error
  }
}

export const urlWithVersion = (url: string) => {
  return `${url}?v=${Date.now()}`
}
